module.exports = __webpack_public_path__ + "img/core-active-4.7f207ab.png";